<template>
  <div class="pa-5" id="summary">
   <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
 <div class="row">
<v-col>
 <v-card-text class="summary" style="white-space:pre-wrap; word-wrap:break-word; margin-top:-1rem;">
                {{ description }}
                <router-link :to="{ path: '/Contact'}" append>お問い合わせください。</router-link>
          </v-card-text>
          </v-col>
</div>
</div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '概要',
      // タイトル横のアイコン
      icon: 'mdi-message-bulleted',
      // 説明文
      description: `
学術研究機関向けのホームページを作成いたします。
更新が多い場合はCMS(content management system)をお勧めしています。
会員サイト等が必要な場合や、レイアウトに自由度が必要な場合はサーバーを用意してJoomla等オープンソースのCMSを導入しますが、そうでない場合はWIX、Jimdo、Googleサイト等の無料Webサイト作成ツールを用いた構築も可能です。
Joomla等のオープンソースのCMSを利用した場合は、自由度が高くなりますが、サーバーが必要となり、セキュリティアップデートも必要となるため、保守費用が月々必要となりますが、WIX、Jimdo、Googleサイト等の無料Webサイト作成ツールの場合は、制限がきつくなりますが、月々の保守費用が必要なくなりますので、ランニングコストを抑えることができます。
ご予算に合わせてご提案いたしますので、`
    }
  }
}
</script>
